/* eslint-disable no-undef */
import React from 'react';
import { Slider } from 'antd';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import { cloneDeep } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { FormattedMessage as FM } from 'react-intl';

const awaitTime = time => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(true);
    }, time);
  });
};

/**
 * 编辑地点
 */
class EditPlace extends React.Component {
  static propTypes = {
    mapKey: PropTypes.string
  };
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.containerId = uuidv4();

    this.state = {};
  }

  componentDidMount = async () => {
    await this.getCurrentLocationByIp();
    await awaitTime(100);
    this.initMap();
    this.initMultiMarker();
    this.initMultiCycle();

    this.multiMarker.add({
      id: this.multiMarkerId,
      position: new TMap.LatLng(
        this.currentLocation.lat,
        this.currentLocation.lng
      )
    });

    this.multiCircle.add({
      id: this.multiCircleId,
      center: new TMap.LatLng(
        this.currentLocation.lat,
        this.currentLocation.lng
      ),
      radius: this.props.radius
    });

    const { onLocationChange } = this.props;
    onLocationChange && onLocationChange(cloneDeep(this.currentLocation));

    this.addEventListener();
  };

  multiMarkerId = 0;
  multiCircleId = 0;

  addEventListener = () => {
    const { onLocationChange } = this.props;
    // 监听点击事件添加 marker
    this.map.on('click', evt => {
      this.currentLocation = evt.latLng;
      this.multiMarker.updateGeometries({
        id: this.multiMarkerId,
        position: this.currentLocation
      });
      this.multiCircle.updateGeometries({
        id: this.multiCircleId,
        center: this.currentLocation,
        radius: this.props.radius
      });
      onLocationChange && onLocationChange(cloneDeep(this.currentLocation));
    });
  };

  currentLocation = null;
  getCurrentLocationByIp = async () => {
    const { location } = this.props;
    let currentLocation;
    if (location && location.lat && location.lng) {
      currentLocation = location;
    } else {
      const ipLocation = new TMap.service.IPLocation();
      const ipLocationResult = await ipLocation.locate();
      currentLocation = ipLocationResult.result.location;
    }
    this.currentLocation = currentLocation;
  };

  map = null;
  initMap = async () => {
    const center = new TMap.LatLng(
      this.currentLocation.lat,
      this.currentLocation.lng
    ); // 设置中心点坐标
    // 初始化地图
    this.map = new TMap.Map(this.containerId, {
      center: center
    });
  };

  multiMarker = null;
  initMultiMarker = () => {
    this.multiMarker = new TMap.MultiMarker({
      id: 'marker-layer',
      map: this.map
    });
  };

  multiCircle = null;
  initMultiCycle = () => {
    this.multiCircle = new TMap.MultiCircle({
      map: this.map,
      styles: {
        // 设置圆形样式
        circle: new TMap.CircleStyle({
          color: 'rgba(41,91,255,0.16)',
          showBorder: true,
          borderColor: 'rgba(41,91,255,1)',
          borderWidth: 2
        })
      }
    });
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (
      prevProps.radius !== this.props.radius &&
      typeof this.props.radius === 'number'
    ) {
      this.multiCircle.updateGeometries({
        id: this.multiCircleId,
        center: new TMap.LatLng(
          this.currentLocation.lat,
          this.currentLocation.lng
        ),
        radius: this.props.radius
      });
    }
    if (
      prevProps.cityCode !== this.props.cityCode ||
      prevProps.cityPosition !== this.props.cityPosition
    ) {
      this.handleSearch(this.props.cityCode, this.props.cityPosition);
    }
  };

  handleSearch = debounce(async (cityCode, cityPosition) => {
    console.log('handleSearch:', cityCode, cityPosition);
    const { mapKey, onLocationChange } = this.props;
    if (cityCode && cityPosition) {
      const data = {
        boundary: `region(${encodeURI(cityCode)},0)`,
        keyword: encodeURI(cityPosition),
        page_size: 20,
        page_index: 1,
        key: mapKey,
        output: 'jsonp'
      };

      $.ajax({
        type: 'get',
        dataType: 'jsonp',
        data: data,
        jsonp: 'callback',
        jsonpCallback: 'getSearchResult',
        url: 'https://apis.map.qq.com/ws/place/v1/search',
        success: res => {
          console.log({ res });
          if (res && Array.isArray(res.data) && res.data.length) {
            console.log('res.data[0]:', res.data[0]);
            const location = res.data[0].location;
            this.currentLocation = location;
            this.map.setCenter(new TMap.LatLng(location.lat, location.lng));
            this.multiMarker.updateGeometries({
              id: this.multiMarkerId,
              position: new TMap.LatLng(location.lat, location.lng)
            });
            this.multiCircle.updateGeometries({
              id: this.multiCircleId,
              center: new TMap.LatLng(location.lat, location.lng),
              radius: this.props.radius
            });
            onLocationChange &&
              onLocationChange(cloneDeep(this.currentLocation));
          }
        },
        error: err => {
          message.error(err.message);
        }
      });
    }
  }, 500);

  handleRadiusChange = radius => {
    const { onRadiusChange } = this.props;
    onRadiusChange && onRadiusChange(radius);
  };

  render() {
    const { fenceSizeMax = 1000, radius } = this.props;
    return (
      <div className="edit-place">
        <div id={this.containerId} style={{ width: '100%', height: 200 }} />
        <div className="edit-place__fence-size">
          <div>
            <FM id="ClockInPlace.fenceSize" defaultMessage="范围大小" />
          </div>
          <Slider
            value={radius}
            max={fenceSizeMax}
            className="edit-place__slider"
            onChange={this.handleRadiusChange}
          />
        </div>
      </div>
    );
  }
}

export default EditPlace;
